import BatchProductListActions from './BatchProductListActions'

export default BatchProductListActions
